<!-- Apollo watched Graphql query -->
<template lang="pug">
    ApolloQuery(:query="require('../graphql/Home.gql')", :variables="{ locale }")
        template(slot-scope="{ result: { data }, isLoading }")
            Loading(v-if="isLoading" :active="isLoading")
            page-not-found(v-else-if="!(data && data.home)")
            .home(v-else)
                MetaTags(v-bind="data.home.meta_tags")
                .cover
                    .cover__inner
                    .cover__item
                        img.cover__img(v-bind="data.home.cover.default").d-none.d-md-block
                        img.cover__img(v-bind="data.home.cover.mobile").d-block.d-md-none
                .intro.container-fluid
                    .row
                        .col-12.intro__head
                            .intro__textarea
                                .intro__headText.intro__headText-bold
                                    | {{data.home.mission_statement_bold}}
                                .intro__headText
                                    | {{data.home.mission_statement_regular}}
                .intro.container
                    .row.intro__content
                        .col-12.col-md-5.intro__graphic
                            img.intro__img(v-bind="data.home.mission_statement_image.default").d-block
                            //- img.intro__img(:src='data.home.mission_statement_image.mobile', alt='').d-none.d-md-block.d-lg-block
                        .col-12.col-md-7.intro__detail
                            .intro__text(v-html="data.home.mission_statement_body")
                            .intro__text.intro__text-hl(v-html="data.home.mission_statement_footer")
                WidgetRecruit(:header="data.home.jobs_header", :image="data.home.jobs_image.default", :href="data.home.jobs_url", :jobs="data.home.jobs", :btn_more_jobs="data.home.btn_more_jobs")
                WidgetCard(v-for="(repeater, index) in data.home.image_with_text", v-bind:key="index", v-bind="repeater", :locale="locale")
                WidgetHowToJoin(v-if="data.home.page_bottom", v-bind="data.home.page_bottom")
</template>

<script>
    import WidgetRecruit from "../components/WidgetRecruit.vue";
    import WidgetCard from "../components/WidgetCard.vue";
    import WidgetHowToJoin from "../components/WidgetHowToJoin.vue";
    import Loading from "../components/Loading.vue";
    import PageNotFound from './PageNotFound';
    import MetaTags from '../components/MetaTags';

    export default {
        name: "home",
        props: {
            locale: String
        },
        components: {
            MetaTags,
            PageNotFound,
            WidgetRecruit,
            WidgetCard,
            WidgetHowToJoin,
            Loading
        }
    };
</script>

<style lang="sass" scoped>
    @import "../../node_modules/bootstrap/scss/functions"
    @import "../assets/styles/CustomVariables"
    @import "../../node_modules/bootstrap/scss/variables"
    @import "../../node_modules/bootstrap/scss/mixins"
    @import "../../node_modules/bootstrap/scss/reboot"
    @import "../../node_modules/bootstrap/scss/grid"
    $color-blue-light: #a7eafa;

    .home
        .intro
            @include media-breakpoint-down(md)
                padding-left: 0
                padding-right: 0

            &__head
                padding-top: 2rem
                padding-bottom: 2rem
                background: $color-blue-light

            &__textarea,
            &__content
                @extend .container

            &__textarea
                color: #696d6c
                @include media-breakpoint-down(md)
                    // text-align: justify
            &__headText
                font-weight: bold
                display: inline
                float: left
                font-size: 1.875rem
                @include media-breakpoint-down(md)
                    display: inline
                    text-align: left
                    font-size: 1rem
                &-bold
                    display: inline
                    width: 100%
                    float: left
                    font-size: 2.5rem
                    @include media-breakpoint-down(md)
                        width: auto
                        font-weight: bold
                        text-align: left
                        font-size: 1.4rem

            &__graphic
                margin-top: -6rem
                @include media-breakpoint-down(md)
                    margin-top: -5rem
                    margin-bottom: 2rem

            &__graphic,
            &__detail
                @include media-breakpoint-down(md)
                    padding-left: 0
                    padding-right: 0

            &__text
                margin-bottom: 2rem
                font-size: 1.25rem

                &:not(&-h1)
                    line-height: 1.8
                @include media-breakpoint-down(md)
                    font-size: 1rem

                &-hl
                    font-size: 1.75rem
                    color: $color-blue-light
                    @include media-breakpoint-down(md)
                        font-size: 1rem

            &__content
                padding-top: 4rem
                @include media-breakpoint-down(md)
                    margin-left: 0
                    margin-right: 0
        .cover__item img
            width: 100%
</style>
